import axios from 'axios'
import { REACT_APP_COTIZADOR_API } from 'cfgCommon/config'

export const getQuotationById = async (quotationId) => {
    try {
        const endpoint = `${REACT_APP_COTIZADOR_API}/cotizador/v1/quotes/${quotationId}`
        const data = await axios.get(endpoint)
        const newQuoteResponse = data.data
        return newQuoteResponse
    } catch (error) {
        throw new error
    }
}